import React from 'react';
import defaultSettings from './data/defaultSettings';
import messages from './translations';
import Router from './Router';
import { library } from '@fortawesome/fontawesome-svg-core';
import * as icons from './icons';
import AppProvider from '@afosto/app-components-react/AppProvider';
import SessionManager from '@afosto/auth/SessionManager';
import { ReactQueryDevtools } from 'react-query-devtools';
import { QueryCache, ReactQueryCacheProvider, ReactQueryConfigProvider } from 'react-query';

SessionManager.client = {
  id: process.env.REACT_APP_FULFILMENT_CLIENT_ID,
  scopes: [
    'iam:logs:read',
    'iam:subscriptions:read',
    'cnt:index:read',
    'cnt:index:write',
    'cnt:files:read',
    'cnt:files:write',
    'cnt:filesystems:read',
    'cnt:filesystems:write',
    'lcs:handling:read',
    'lcs:handling:write',
    'lcs:locations:read',
    'lcs:locations:write',
    'lcs:shipments:read',
    'lcs:shipments:write',
    'lcs:points:read',
    'rel:contacts:read',
    'rel:contacts:write',
    'odr:skus:write',
    'spl:queue:create',
    'spl:queue:read',
    'spl:printers:read',
    'spl:hubs:read',
    'odr:orders:read',
    'wms:item:read',
    'wms:location:read',
    'app:integrations:read',
  ],
};

library.add(icons);

const queryCache = new QueryCache({
  defaultConfig: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => (
  <ReactQueryCacheProvider queryCache={queryCache}>
    <ReactQueryConfigProvider config={{}}>
      <AppProvider app="lcs" state={{ settings: defaultSettings }} messages={messages}>
        <Router />
      </AppProvider>
      <ReactQueryDevtools initialIsOpen />
    </ReactQueryConfigProvider>
  </ReactQueryCacheProvider>
);

export default App;
